import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Send a GA4 `page_view` event on every React Router navigation.
 *
 * Why manual? gtag's default `config` call ONLY tracks the first URL a
 * visitor lands on. Because the portfolio is a SPA (Home → /project/:slug
 * → back), all subsequent navigations would otherwise be invisible in GA.
 * We pair this hook with `send_page_view: false` in the config call
 * inside public/index.html so the first page-view isn't double-counted.
 *
 * Safe no-op when gtag isn't loaded (preview, admin, or ad-blocker) —
 * we type-check `window.gtag` before firing.
 *
 * Also filters out the /admin route so administrator activity doesn't
 * show up in the audience reports.
 */
export default function useAnalytics() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    // Don't count admin sessions as visitor traffic.
    if (location.pathname.startsWith("/admin")) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}
